import { CONTRACT_TYPES } from '@/lib/constants/contractTypes'

let getContractTypeLabel = (contractTypeId) => {
  return CONTRACT_TYPES[contractTypeId]
}

export default getContractTypeLabel
